import { getStaticAssetUrl } from 'utils/url';

export interface TestLevel {
  title: string;
  points: number;
  level: 'bronze' | 'silver' | 'gold';
  image: string;
  activeImage: string;
}

export const testnetLevel: TestLevel[] = [
  {
    title: 'Bronze',
    points: 0,
    level: 'bronze',
    image: getStaticAssetUrl('/sfi/static/dashboard/bronze/bronze.svg'),
    activeImage: getStaticAssetUrl(
      '/sfi/static/dashboard/bronze/bronze_active.svg'
    ),
  },
  {
    title: 'Gold',
    points: 0,
    level: 'gold',
    image: getStaticAssetUrl('/sfi/static/dashboard/gold/gold_active.svg'),
    activeImage: getStaticAssetUrl(
      '/sfi/static/dashboard/gold/gold_active.svg'
    ),
  },
  {
    title: 'Silver',
    points: 0,
    level: 'silver',
    image: getStaticAssetUrl('/sfi/static/dashboard/silver/silver.svg'),
    activeImage: getStaticAssetUrl('/sfi/static/dashboard/silver/silver.svg'),
  },
];

export const dashboardInfoResponse = {
  zealyId: 'cd46db0e-260e-4e3d-8384-6b27feff4b95',
  zealyName: 'Shyam_123',
  pointsEarnedToday: 0,
  maxPointsAvailableToday: 27000,
  totalPoints: 18000,
  level: 'gold',
  quests: [
    {
      id: 'join-telegram',
      category: 'get-started',
      title: 'Join us on Telegram',
      points: 5000,
      status: 'available',
      claimFrequency: 'once',
      redirectUrl:
        'https://zealy.io/cw/singularityfinance/questboard/c372adaa-a8af-4e05-be96-56d70c71accd/a4826197-1226-4b6e-b4a8-6a7511608d5f',
      imageUrl: '/sfi/dashboard/telegram.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 1,
    },
    {
      id: 'follow-twitter',
      category: 'get-started',
      title: 'Join us on Twitter',
      points: 5000,
      status: 'available',
      claimFrequency: 'once',
      redirectUrl:
        'https://zealy.io/cw/singularityfinance/questboard/c372adaa-a8af-4e05-be96-56d70c71accd/3abf305e-337c-478a-bd08-77120d44f098',
      imageUrl: '/sfi/dashboard/twitter.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 1,
    },
    {
      id: 'crymboTravelRule',
      category: 'todays-mission',
      title: 'Travel Rule',
      points: 1000,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: 'https://www.crymbo.com/oracle-partners',
      imageUrl: '/sfi/dashboard/crymbo.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 3,
    },
    {
      id: 'retweet-post',
      category: 'get-started',
      title: 'Retweet project posts',
      points: 500,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl:
        'https://zealy.io/cw/singularityfinance/questboard/c372adaa-a8af-4e05-be96-56d70c71accd/dda0e859-57a1-4f68-80e9-4c4fbff891ca',
      imageUrl: '/sfi/dashboard/twitter.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 1,
    },
    {
      id: 'inviteGetPoints',
      category: 'get-started',
      title: 'Invite and get points',
      points: 100,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl:
        'https://zealy.io/cw/singularityfinance/questboard/c372adaa-a8af-4e05-be96-56d70c71accd/a25a49cd-836f-4a55-9d30-d7a35ce4cc6a',
      imageUrl: '/sfi/dashboard/staking-tokens.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 10,
    },
    {
      id: 'dexSwap',
      category: 'todays-mission',
      title: 'DEX Swap',
      points: 500,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: 'https://dapp.citeazens.io/dex',
      imageUrl: '/sfi/dashboard/dex.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 3,
    },
    {
      id: 'dexRemoveLiquidity',
      category: 'todays-mission',
      title: 'DEX Remove Liquidity',
      points: 500,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: 'https://dapp.citeazens.io/dex',
      imageUrl: '/sfi/dashboard/dex.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 1,
    },
    {
      id: 'dexAddLiquidity',
      category: 'todays-mission',
      title: 'DEX Add Liquidity',
      points: 500,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: 'https://dapp.citeazens.io/dex',
      imageUrl: '/sfi/dashboard/dex.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 1,
    },
    {
      id: 'stake-tokens',
      category: 'todays-mission',
      title: 'Staking Tokens',
      points: 2000,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: '/testnet/staking',
      imageUrl: '/sfi/dashboard/staking-tokens.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 2,
    },
    {
      id: 'unstake-tokens',
      category: 'todays-mission',
      title: 'Unstaking',
      points: 2000,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: '/testnet/staking',
      imageUrl: '/sfi/dashboard/unstaking-tokens.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 1,
    },
    {
      id: 'staking-claim',
      category: 'todays-mission',
      title: 'Staking claim',
      points: 2000,
      status: 'available',
      claimFrequency: 'daily',
      redirectUrl: '/testnet/staking',
      imageUrl: '/sfi/dashboard/staking-tokens.svg',
      numberOfClaims: 0,
      maxNumberOfClaims: 2,
    },
  ],
};
